import * as React from "react";

const StockInStock: React.FC = () => {
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill="currentColor"
                d="M6,12.5 C8.14359382,12.5 10.1243558,11.3564062 11.196153,9.5 C12.2679494,7.64359379 12.2679494,5.35640657 11.196153,3.5 C10.1243558,1.64359379 8.14359382,0.5 6,0.5 C3.85640672,0.5 1.87564436,1.64359379 0.803847581,3.5 C-0.267949194,5.35640657 -0.267949194,7.64359379 0.803847581,9.5 C1.87564436,11.3564062 3.85640672,12.5 6,12.5 Z M5.64843777,8.3984375 L5.25000027,8.796875 L4.85156277,8.3984375 L2.97656277,6.5234375 L3.77343777,5.7265625 L5.25000027,7.203125 L8.22656277,4.2265625 L9.02343777,5.0234375 L5.64843777,8.3984375 Z"
                transform="translate(0 -.5)"
            />
        </svg>
    );
};

export default React.memo(StockInStock);
